// The one landing decision shared by LoginPage and the root route; customers are patient-audience, so they land on /patient too.
import type { User } from "../../types/admin/UserTypes";
import { isPatientSession } from "../userPrefs/validatePermissions";

export type AuthenticatedHome = "/patient" | "/customer" | "/";

export const resolveAuthenticatedHome = (user: Partial<Pick<User, "user_type">> | null | undefined): AuthenticatedHome => {
	if (isPatientSession()) return "/patient";
	if (user?.user_type === "customer") return "/customer";

	return "/";
};
